import { useSSE } from './sse'

export function useJobEvents() {
    const sse = useSSE('platform/events/jobs')

    const initialize = (handlers = {}) => {
        // Register event listeners BEFORE connecting to avoid race conditions
        // where the server sends events before listeners are attached

        // Connection event - received on initial connect with current sequence ID
        sse.addEventListener('connected', (data) => {
            console.debug('[JobEvents] Connected, server sequenceId:', data.sequenceId)
            if (handlers.onConnected) {
                handlers.onConnected(data)
            }
        })

        // Job lifecycle events
        if (handlers.onJobStarted) {
            sse.addEventListener('job.started', handlers.onJobStarted)
        }

        if (handlers.onJobProgress) {
            sse.addEventListener('job.progress', handlers.onJobProgress)
        }

        if (handlers.onJobCompleted) {
            sse.addEventListener('job.completed', handlers.onJobCompleted)
        }

        if (handlers.onJobFailed) {
            sse.addEventListener('job.failed', handlers.onJobFailed)
        }

        // Now connect - listeners are already registered in the map
        // and will be attached to eventSource in onopen or immediately if connecting
        sse.connect()
    }

    // Reset sequence tracking (e.g., on logout)
    const reset = () => {
        sse.resetSequence()
        sse.disconnect()
    }

    return {
        initialize,
        disconnect: sse.disconnect,
        reset,
        isConnected: sse.isConnected,
        error: sse.error,
        retryCount: sse.retryCount,
        lastSequenceId: sse.lastSequenceId
    }
}
